/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import { CallButtonVehicleFragmentDoc } from '../../../../ad-operator-call/src/lib/components/CallButton/CallButton.hook'
import { AdPassengerRowCustomerFragmentDoc } from '../../../../ad-passenger-list/src/lib/components/AdPassengerRow/AdPassengerRow.hook'
import {
  GetPassengersDeliveryActionFragmentDoc,
  GetPassengersPickupActionFragmentDoc,
  GetPassengersWaypointFragmentDoc,
} from '../../../../ad-passenger-list/src/lib/utils/passenger-filters.hook'
import { AdPoolingToggleVehicleFragmentDoc } from '../../../../ad-pooling-toggle/src/lib/AdPoolingToggle.hook'
import { BookabilityCardVehicleFragmentDoc } from '../../../../ad-telematics-cards/src/lib/BookabilityCard/BookabilityCard.hook'
import { AdVehicleStreamHubReturnVehicleFragmentDoc } from '../../../../ad-vehicle-stream/src/lib/HubReturn/graphql/HubReturnVehicle.hook'
import { AdVehicleStreamServiceCancellationVehicleFragmentDoc } from '../../../../ad-vehicle-stream/src/lib/ManageService/ManageService.hook'
import { VehicleDrawerStatusBarVehicleFragmentDoc } from '../../../../fleet-maps-common/src/lib/components/Drawer/VehicleDrawerStatusBar.hook'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
import { AdVehicleDrawerHeaderVehicleFragmentDoc } from './AdVehicleDrawerHeader/AdVehicleDrawerHeader.hook'
import { AdVehicleMenuVehicleFragmentDoc } from './AdVehicleMenu/AdVehicleMenu.hook'

const defaultOptions = {} as const
export type AdVehicleDrawerQueryVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
  withAdTelemetryData: Types.Scalars['Boolean']['input']
}>

export type AdVehicleDrawerQuery = {
  __typename?: 'Query'
  vehicle: {
    __typename?: 'Vehicle'
    id: string
    inService: boolean | null
    label: number | null
    notInServiceReasons: Array<Types.NotInServiceReason> | null
    isSelfDriving: boolean
    isResponsive: boolean | null
    latestADTelemetry: {
      __typename?: 'ADTelemetry'
      sdsMode: {
        __typename?: 'SDSModeWithTimestamp'
        sdsMode: Types.SdsMode
      } | null
      signalConnectivityState: {
        __typename?: 'ADConnectivityStateWithTimestamp'
        connectivityState: Types.AdConnectivityState
        timestamp: string
      } | null
      cabinConnectivityState: {
        __typename?: 'ADConnectivityStateWithTimestamp'
        connectivityState: Types.AdConnectivityState
        timestamp: string
      } | null
      missionConnectivityState: {
        __typename?: 'ADConnectivityStateWithTimestamp'
        connectivityState: Types.AdConnectivityState
        timestamp: string
      } | null
    } | null
    fccHandledByOperator: { __typename?: 'BackofficeUser'; id: string } | null
    fccHandledByOperatorDetails: {
      __typename?: 'BackofficeUser'
      firstName: string
      lastName: string
    } | null
    pooling: {
      __typename?: 'Pooling'
      enabled: boolean
      enabledUpdatedAt: string | null
      reason: Types.PoolingReason | null
      connected: boolean | null
      connectedUpdatedAt: string | null
    } | null
    fccCurrentAdAlerts: {
      __typename?: 'FccAdAlerts'
      alerts: Array<{
        __typename?: 'FccAdAlert'
        id: string
        type: Types.FccAdAlertType
        status: Types.FccAdAlertStatus
      }>
    } | null
    fccUpcomingWaypoints: Array<{
      __typename?: 'FccWaypoint'
      adState: Types.FccWaypointState | null
      actions: Array<
        | {
            __typename: 'FccWaypointDeliveryAction'
            id: string
            estimatedAt: string
            pickedUpAt: string | null
            trip: { __typename?: 'Trip'; id: string } | null
            customer: {
              __typename?: 'Customer'
              firstName: string | null
              lastName: string | null
              extendedWalkingTime: boolean
              visualImpairment: boolean | null
            } | null
            ridePassengerInfo: {
              __typename?: 'FccRidePassengerInfo'
              customerId: string | null
              displayName: string | null
              boardingRequirements: {
                __typename?: 'FccBoardingRequirements'
                headCount: number
                childSeat: boolean
                wheelchair: boolean
              } | null
              impairments: {
                __typename?: 'FccImpairments'
                visual: boolean
              } | null
            } | null
          }
        | { __typename: 'FccWaypointHubReturnAction'; id: string }
        | {
            __typename: 'FccWaypointPickupAction'
            id: string
            estimatedAt: string
            pickedUpAt: string | null
            adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
            notShownUpAt: string | null
            tripIsCancelled: boolean | null
            trip: { __typename?: 'Trip'; id: string } | null
            customer: {
              __typename?: 'Customer'
              firstName: string | null
              lastName: string | null
              extendedWalkingTime: boolean
              visualImpairment: boolean | null
            } | null
            ridePassengerInfo: {
              __typename?: 'FccRidePassengerInfo'
              customerId: string | null
              displayName: string | null
              boardingRequirements: {
                __typename?: 'FccBoardingRequirements'
                headCount: number
                childSeat: boolean
                wheelchair: boolean
              } | null
              impairments: {
                __typename?: 'FccImpairments'
                visual: boolean
              } | null
            } | null
          }
        | { __typename: 'FccWaypointReallocationAction' }
      >
      fccStop: {
        __typename?: 'FccStop'
        id: string | null
        names: Partial<Record<'de' | 'en' | 'no', string>>
      } | null
      stopWithServiceArea: {
        __typename?: 'Stop'
        id: string
        serviceArea: { __typename?: 'ServiceArea'; id: string }
      } | null
    }> | null
    fleet: { __typename?: 'Fleet'; id: string } | null
    region: { __typename?: 'Region'; id: string } | null
  }
}

export const AdVehicleDrawerDocument = gql`
    query adVehicleDrawer($vehicleId: ID!, $withAdTelemetryData: Boolean!) {
  vehicle: vehicleByID(id: $vehicleId) {
    id
    latestADTelemetry {
      sdsMode {
        sdsMode
      }
    }
    ...AdVehicleDrawerHeaderVehicle
    ...VehicleDrawerStatusBarVehicle
    ...AdVehicleMenuVehicle
    ...CallButtonVehicle
    ...BookabilityCardVehicle
  }
}
    ${AdVehicleDrawerHeaderVehicleFragmentDoc}
${AdPoolingToggleVehicleFragmentDoc}
${VehicleDrawerStatusBarVehicleFragmentDoc}
${AdVehicleMenuVehicleFragmentDoc}
${AdVehicleStreamServiceCancellationVehicleFragmentDoc}
${GetPassengersWaypointFragmentDoc}
${GetPassengersPickupActionFragmentDoc}
${AdPassengerRowCustomerFragmentDoc}
${GetPassengersDeliveryActionFragmentDoc}
${AdVehicleStreamHubReturnVehicleFragmentDoc}
${CallButtonVehicleFragmentDoc}
${BookabilityCardVehicleFragmentDoc}`

/**
 * __useAdVehicleDrawerQuery__
 *
 * To run a query within a React component, call `useAdVehicleDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdVehicleDrawerQuery({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *      withAdTelemetryData: // value for 'withAdTelemetryData'
 *   },
 * });
 */
export function useAdVehicleDrawerQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdVehicleDrawerQuery,
    AdVehicleDrawerQueryVariables
  > &
    (
      | { variables: AdVehicleDrawerQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AdVehicleDrawerQuery, AdVehicleDrawerQueryVariables>(
    AdVehicleDrawerDocument,
    options,
  )
}
export function useAdVehicleDrawerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdVehicleDrawerQuery,
    AdVehicleDrawerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdVehicleDrawerQuery,
    AdVehicleDrawerQueryVariables
  >(AdVehicleDrawerDocument, options)
}
// @ts-ignore
export function useAdVehicleDrawerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdVehicleDrawerQuery,
    AdVehicleDrawerQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdVehicleDrawerQuery,
  AdVehicleDrawerQueryVariables
>
export function useAdVehicleDrawerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdVehicleDrawerQuery,
        AdVehicleDrawerQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdVehicleDrawerQuery | undefined,
  AdVehicleDrawerQueryVariables
>
export function useAdVehicleDrawerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdVehicleDrawerQuery,
        AdVehicleDrawerQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AdVehicleDrawerQuery,
    AdVehicleDrawerQueryVariables
  >(AdVehicleDrawerDocument, options)
}
export type AdVehicleDrawerQueryHookResult = ReturnType<
  typeof useAdVehicleDrawerQuery
>
export type AdVehicleDrawerLazyQueryHookResult = ReturnType<
  typeof useAdVehicleDrawerLazyQuery
>
export type AdVehicleDrawerSuspenseQueryHookResult = ReturnType<
  typeof useAdVehicleDrawerSuspenseQuery
>
export type AdVehicleDrawerQueryResult = Apollo.QueryResult<
  AdVehicleDrawerQuery,
  AdVehicleDrawerQueryVariables
>
